import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import roles from "../helpers/roles.json";
import { getStorage, setStorage } from "../helpers/storage";

export const domainVerificationTxtCode = `montycloud=${uuidv4()}`;

export const initiateSSO = async (id, configData) => {
  const { ProfileId, AcsURL, EntityId, CallbackURL } = await getStorage(
    "SSO_ACTIVE_SETTINGS"
  );
  const { ProfileResourceId, ProviderRealm } = configData;

  let ssoConfig = {
    ApplicationRealm: {
      Settings: {
        AcsURL,
        EntityId,
        AppIntegration: {
          CallbackURL,
        },
      },
    },
    ProviderRealm: {
      ...ProviderRealm,
      SignInURL:
        "https://login.microsoftonline.com/dc9d4e96-7bbd-4b85-b5b4-ef843d969111/saml2",
      IssuerURL:
        "https://sts.windows.net/dc9d4e96-7bbd-4b85-b5b4-ef843d969111/",
      Certificate: `MIIC8DCCAdigAwIBAgIQfBLDwJG6wbJDAhIvPIKuezANBgkqhkiG9w0BAQsFADA0MTIwMAYDVQQDEylNaWNyb3N
        vZnQgQXp1cmUgRmVkZXJhdGVkIFNTTyBDZXJ0aWZpY2F0ZTAeFw0yMDA3MjExMjI5MDJaFw0yMzA3MjExMjI5MDJaMDQxMjAwBgNVBAMTKU1pY3Jvc29mdCB
        BenVyZSBGZWRlcmF0ZWQgU1NPIENlcnRpZmljYXRlMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA02x0Z/Vz/xWB6TCJrQlJU0k3r5MG4nr+uVS
        aDPx5aNpsv6f7u4C2cn3uPIUH+++SGQ54EVdnhveJdPXLnzRcV4fDUiBYbW2VnrdNkJ4YZN8auVUw3nJ1n4xYA/9/eiEcVsvC/ujqENKF6q8LqMxw3wd331P
        uJxnPieNM5BYtiYm6Dmsv48WhWravWJVfSLS8qJTszm8o/ZH3z28HLIAI/zUgSgHROL/j0UAChzbhZ0feJANH0iDElWtkYvrkl/8UtfxRG+XdtoGIVk+HHXi
        ab7lZgx9j9/42ADZPpXLkEuEg6qjSmXNDZ2PYjJkJgpvME4yu29ZOqTtd+AZsRX/mGQIDAQABMA0GCSqGSIb3DQEBCwUAA4IBAQAhwqLhJPrLzVT6KSxgeb8
        /NH3auWArqulkl5u3FqN0J4WmgY/lmsuFGTx49y+05JuIatDkn4GUYFlxck1znRowJxE2NCIzUCRyT/1MfcA213oQPmjIbDfhorV+2GK3t0rQis+14eow/B7
        aChUFAMyVu1D/ZlZetI5hqG+iR1FZ9ZGu610rsMNIgQu30NkWGUsGwvn7K29po6d5DiMnBYfehvr4fLTLG2Q4lySLIsb2xgWGMq9v0okOAO05TK/qwvq3zqs
        mrgQkRm4mQSp/r5l+GwrxiHEbyZjzfaERa2iK365ORly1zEKnsjF1jmW6mSbijoIXFwM6W069kRQYIkwj`,
    },
    Id: id,
    ProfileResourceId,
    ProfileId,
    Status: "INITIATED",
    DomainVerificationTxtCode: domainVerificationTxtCode,
  };
  await setStorage("SSO_CONFIG", ssoConfig);
};

export const getSSOActiveSettings = async () => {
  const profileId = "azure-ad-saml";
  const profileResourceId = uuidv4();
  const settings = {
    ProfileId: profileId,
    ProfileResourceId: profileResourceId,
    EntityId: "urn:amazon:cognito:sp:us-east-1_LCikuEQmf",
    AcsURL:
      "https://montycloud-federation.auth.us-east-1.amazoncognito.com/saml2/idpresponse",
    CallbackURL: " https://demo.montycloud.com/login",
    SPMetadataURL:
      "https://mcdev1customeronboarding.s3.amazonaws.com/MC-SP-Metadata.xml",
  };
  await setStorage("SSO_ACTIVE_SETTINGS", settings);
  return settings;
};

export const getSSORoles = () => {
  return roles;
};

export const editConfig = async (configData, isDisable) => {
  let ssoConfig = (await getStorage("SSO_CONFIG")) || {};

  let data = {};
  if (isDisable) {
    data = {
      ...ssoConfig,
      SubStatus: "DISABLING_SSO_INITIATED",
    };
  } else {
    if (configData.MgmtStatus) {
      data = {
        ...ssoConfig,
        MgmtStatus: configData.MgmtStatus,
      };
    } else {
      const {
        ApplicationRealm: { DefaultDept, DefaultRole },
      } = configData;
      data = {
        ...ssoConfig,
        ApplicationRealm: {
          ...ssoConfig.ApplicationRealm,
          DefaultDept,
          DefaultRole,
        },
        Id: ssoConfig.Id || uuidv4(),
        Status: "COMPLETED",
        ProfileId: "azure-ad-saml",
        Name: ssoConfig.Name || configData.Name,
      };
    }
  }

  await setStorage("SSO_CONFIG", data);
  return data;
};

const setSSOConfig = async (domains) => {
  let ssoConfig = await getStorage("SSO_CONFIG");
  const updatedConfig = {
    ...ssoConfig,
    Domains: domains,
  };
  await setStorage("SSO_CONFIG", updatedConfig);
  await setStorage("CUSTOMER_DOMAINS", domains);
};

export const addDomain = async (data) => {
  const domain = {
    ...data,
    DomainId: uuidv4(),
    Status: "UNVERIFIED",
  };
  let domains = (await getStorage("CUSTOMER_DOMAINS")) || [];
  domains.push(domain);
  await setSSOConfig(domains);
};

export const verifyDomain = async (id) => {
  const domains = (await getStorage("CUSTOMER_DOMAINS")) || [];
  const updatedDomains = domains.map((domain) => {
    let item = {
      ...domain,
    };
    if (domain.DomainId === id) {
      item = {
        ...item,
        Status: "VERIFIED",
      };
    }
    return item;
  });
  await setSSOConfig(updatedDomains);
};

export const deleteDomian = async (id) => {
  const domains = (await getStorage("CUSTOMER_DOMAINS")) || [];
  const updatedDomains = domains.filter((domain) => domain.DomainId !== id);
  await setSSOConfig(updatedDomains);
};
